var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-stepper-step",
        {
          attrs: {
            complete: _vm.step > 2,
            step: "2"
          }
        },
        [_vm._v(" Review ")]
      ),
      _c(
        "v-stepper-content",
        {
          attrs: {
            step: "2"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-sheet",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("h2", [_vm._v(" Summary ")]),
                          _c("p", [
                            _c("strong", [_vm._v(_vm._s(_vm.promo.name))]),
                            _vm._v(" - "),
                            _c("i", [_vm._v(_vm._s(_vm.promo.description))]),
                            _c("br"),
                            _c("strong", [_vm._v("Amount:")]),
                            _vm._v(
                              " " + _vm._s(_vm.moneyFormat(_vm.amount)) + " "
                            )
                          ]),
                          _c("p", [
                            _vm._v("Your service will renew "),
                            _c("b", [_vm._v(_vm._s(_vm.renewalterm))]),
                            _vm._v(" for "),
                            _c("b", [
                              _vm._v(_vm._s(_vm.moneyFormat(_vm.renewalrate)))
                            ]),
                            _vm._v(", starting on "),
                            _c("b", [_vm._v(_vm._s(_vm.renewaldate))]),
                            _vm._v(". "),
                            _c("br"),
                            _c("br")
                          ]),
                          _c("h2", [_vm._v(" Payment Information ")]),
                          _c("p", [
                            _vm._v("Please confirm your payment information.")
                          ]),
                          _c("payment-gateway", {
                            ref: "paymentGateway",
                            attrs: {
                              compact: ""
                            },
                            on: {
                              "card-switch": _vm.cardSwitch,
                              card: _vm.setCard
                            }
                          }),
                          _c("v-checkbox", {
                            attrs: {
                              label:
                                "I agree to the pricing above and approve this charge."
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function callback($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm"
                            }
                          }),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                color: "primary",
                                tile: "",
                                elevation: "0",
                                disabled: !_vm.confirm,
                                loading: _vm.loading
                              },
                              on: {
                                click: _vm.submit
                              }
                            },
                            [_vm._v(" Submit ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }